import React, { useState } from 'react';

function MetaData({ onChange, onInputChange }) {
  const [selectedOption, setSelectedOption] = useState('');
  const [inputValues, setInputValues] = useState({
    inputOneValue: '',
    inputTwoValue: '',
    inputThreeValue: '',
    inputFourValue: '',
  });

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);
    onChange(selectedValue);
  };

  const handleInputChange = (fieldName, value) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
    onInputChange({ ...inputValues, [fieldName]: value });
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    },
    select: {
      width: '100%',
      padding: '10px 12px',
      fontSize: '14px',
      borderRadius: '8px',
      border: '1px solid #E5E7EB',
      backgroundColor: 'white',
      color: '#374151',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236B7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 12px center',
      backgroundSize: '16px',
      cursor: 'pointer'
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    label: {
      fontSize: '14px',
      color: '#374151',
      fontWeight: '500'
    },
    input: {
      width: '90%',
      padding: '10px 12px',
      fontSize: '14px',
      borderRadius: '8px',
      border: '1px solid #E5E7EB',
      backgroundColor: '#F9FAFB',
      color: '#374151',
      transition: 'border-color 0.2s ease',
      outline: 'none'
    }
  };

  const renderInputs = () => (
    <>
      <div style={styles.inputGroup}>
        <label htmlFor="input1" style={styles.label}>Source:</label>
        <input
          type="text"
          id="input1"
          value={inputValues.inputOneValue}
          onChange={(e) => handleInputChange('inputOneValue', e.target.value)}
          placeholder="Enter Source"
          style={styles.input}
        />
      </div>

      <div style={styles.inputGroup}>
        <label htmlFor="input2" style={styles.label}>Colour:</label>
        <input
          type="text"
          id="input2"
          value={inputValues.inputTwoValue}
          onChange={(e) => handleInputChange('inputTwoValue', e.target.value)}
          placeholder="Enter colour"
          style={styles.input}
        />
      </div>

      <div style={styles.inputGroup}>
        <label htmlFor="input3" style={styles.label}>Associated publication:</label>
        <input
          type="text"
          id="input3"
          value={inputValues.inputThreeValue}
          onChange={(e) => handleInputChange('inputThreeValue', e.target.value)}
          placeholder="Enter Source"
          style={styles.input}
        />
      </div>

      <div style={styles.inputGroup}>
        <label htmlFor="input4" style={styles.label}>Description:</label>
        <input
          type="text"
          id="input4"
          value={inputValues.inputFourValue}
          onChange={(e) => handleInputChange('inputFourValue', e.target.value)}
          placeholder="Enter Description"
          style={styles.input}
        />
      </div>
    </>
  );

  return (
    <div style={styles.container}>
      <div style={styles.inputGroup}>
        <label htmlFor="dropdown" style={styles.label}>Select an option:</label>
        <select 
          id="dropdown" 
          value={selectedOption}
          onChange={handleSelectChange}
          style={styles.select}
        >
          <option value="">Select</option>
          <option value="Virgin">Virgin</option>
          <option value="Consumer">Consumer</option>
          <option value="Environmental">Environmental</option>
        </select>
      </div>

      {selectedOption && renderInputs()}
    </div>
  );
}

export default MetaData;